<template>
  <v-card flat class="pl-4">
    <v-list-item class="pl-0">
      <v-list-item-avatar color="black">
        <v-icon color="white">{{icon.mdiAccount}}</v-icon>
      </v-list-item-avatar>

      <v-list-item-content>
        <v-list-item-title v-text="review.reviewerName"></v-list-item-title>

        <div class="caption">
          Status:
          <span :style="`color: ${getStatusColor(review.status)};`">{{
            review.status
          }}</span>
        </div>
      </v-list-item-content>

      <v-list-item-action>
        <v-row>
          <v-btn icon @click="sendEmail()">
            <v-icon> {{icon.mdiEmail}} </v-icon>
          </v-btn>
          <v-btn icon @click="removeReviewer()">
            <v-icon> {{icon.mdiClose}} </v-icon>
          </v-btn>
        </v-row>
      </v-list-item-action>
    </v-list-item>
    <div class="subtitle-2 grey--text pt-6">Review</div>
    <v-card-text class="pl-0">{{
      review.review ? review.review : "Not reviewed yet"
    }}</v-card-text>
  </v-card>
</template>

<script>
import paperStatus from "@/helpers/paperStatus.js";
import {mdiClose, mdiEmail, mdiAccount } from '@mdi/js';

export default {
  props: ["review", "reviews", "paper"],
  data: () => ({
    icon:{
      mdiClose,
      mdiEmail,
      mdiAccount
    },
  }),
  methods: {
    sendEmail() {
    },
    async removeReviewer() {
      await this.$store.dispatch("removeToReview", {
        id: this.reviewerId,
        element: this.paper.id,
      });

      this.$emit("removeReviewer", this.reviewerId);
    },
    getStatusColor(status) {
      return paperStatus.getStatusColor(status);
    },
  },
  computed: {
    reviewerId() {
      let index = Object.values(this.reviews).indexOf(this.review);

      return Object.keys(this.reviews)[index];
    },
  },
};
</script>